const config = {
    companyName: "Преобразование",
    companyDescription: "Мы ведущая IT-компания, специализирующаяся на разработке и внедрении передовых программных решений. Мы предлагаем полный спектр услуг. Наши высококвалифицированные специалисты стремятся к созданию продуктов, которые превосходят ожидания клиентов и помогают им достигать своих целей.",
    companyFullName: "ООО «Преобразование»",
    inn: "7807404580",
    ogrn: "1267800018540",
    kpp: "780701001",
    okved: "62.01 - Разработка компьютерного программного обеспечения",
    keyServices: [
        {
            name: "Разработка компьютерного программного обеспечения"
        },
        {
            name: "Деятельность консультативная и работы в области компьютерных технологий"
        },
        {
            name: "Деятельность по планированию, проектированию компьютерных систем"
        },
        {
            name: "Деятельность по подготовке компьютерных систем к эксплуатации"
        },
        {
            name: "Деятельность по сопровождению компьютерных систем"
        }
    ],
    companyAddress: "198323, г. Санкт-Петербург, вн. тер. г. муниципальный округ Горелово, тер. Горелово, ш. Аннинское, д. 26А стр. 1, помещ. А 6/3/3",
    companyPhone: "+7 (931) 277-76-95",
    companyEmail: "accounting@preobrazovanie.com",
};

export default config;
